import { Configuration } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AUTH_CLIENT_ID,
    authority: import.meta.env.VITE_AUTH_AUTHORITY,
    knownAuthorities: [import.meta.env.VITE_AUTH_KNOWN_AUTHORITIES],
    redirectUri: import.meta.env.VITE_AUTH_REDIRECT_URI,
    postLogoutRedirectUri: import.meta.env.VITE_REACT_APP_LOGOUT_URL,
  },
  cache: {
    cacheLocation: 'localStorage', // or "sessionStorage"
  },
};
